export const InitializingReviewReloadPollingInterval = 20000;
